import { useQuery } from '@tanstack/react-query';
import type { AzdoBranch } from '../../api/azdo-lookup';
import { azdoLookupApi } from '../../api/azdo-lookup/client';
import { useWithAccessToken } from '../../auth/use-with-access-token';

export interface UseRepositoryBranchesResult {
  branches: AzdoBranch[];
  loading: boolean;
  error: string | null;
}

export const useRepositoryBranches = (
  projectId: string | null,
  repositoryId: string | null,
): UseRepositoryBranchesResult => {
  const queryFn = useWithAccessToken((config) =>
    azdoLookupApi.listRepositoryBranches(projectId ?? '', repositoryId ?? '', config),
  );
  const query = useQuery({
    queryKey: ['azdo', 'branches', projectId, repositoryId],
    queryFn: async () => (await queryFn()).data,
    enabled: Boolean(projectId && repositoryId),
  });
  return {
    branches: query.data ?? [],
    loading: query.isFetching,
    error: query.error ? (query.error as Error).message : null,
  };
};
